import { render } from "./TypingLoader.vue?vue&type=template&id=631c25f4&scoped=true"
const script = {}

import "./TypingLoader.vue?vue&type=style&index=0&id=631c25f4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-631c25f4"]])

export default __exports__